export type { NextPage, GetServerSidePropsResult, GetServerSideProps, InferGetServerSidePropsType } from 'next';
export type { AppProps } from 'next/app';

export { default as NextDocument } from 'next/document';
export { default as Head } from 'next/head';
export { default as Script } from 'next/script';
export { default as dynamic } from 'next/dynamic';

export { Html, Main, NextScript, Head as DocumentHead } from 'next/document';

export { Body as DocumentBody } from './Body';
export { Link } from './Link';
export { useRouter, useLocales, RouterContext } from './useRouter';
export type { UseRouter } from './useRouter';
export { Router, RouterProvider, Routes, Route, errorPaths } from './Router';
